import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import {mask} from 'vue-the-mask'
import Forms from '@/components/forms/Forms'
import Tables from '@/components/forms/Tables'
import TableColumn from '@/components/forms/TableColumn'
import { JWTService } from '@/shared/services/jwt'
// import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'
const ipify = require('ipify2')

export default {
  name: 'actionForms',
  // mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles,
      permissions: null,
      data: null,
      form: null,
      objList: null,
      error: null,
      polling: null,
      latitude: null,
      longitude: null,
      ip: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  directives: {mask},
  components: {
    Forms,
    Tables,
    TableColumn
  },
  computed: {
    FieldSizeTip: function () {
      var result = ''
      if (this.form.hasOwnProperty('description')) {
        result = this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
      }
      return result
    }
  },
  created () {
    this.getLocation()
    this.getIp()
  },
  mounted () {
    Tools.MinimizedSidebar()
    this.onClear()
    this.onLoad()
    this.permissions = JWTService.GetRoles()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onSave () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        // Set default data
        // this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        // this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('tenantID')) {
          this.data.tenantID = JWTService.GetTokenPayload().tenantID
        }

        if (this.data) {
          if (this.data.id && this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.data.status = parseInt(this.data.status)
            this.onUpdate()
          } else {
            this.data.id = null // '00000000-0000-0000-0000-000000000000'
            this.data.status = 1
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onSearch () {
      console.log('Warning: Override method in your view implementation onSearch()')
    },
    onLoad () {
      console.log('Warning: Override method in your view implementation onLoad()')
    },
    onCreate () {
      console.log('Warning: Override method in your view implementation onCreate()')
    },
    onUpdate () {
      console.log('Warning: Override method in your view implementation onUpdate()')
    },
    onChange (obj) {
      for (var key in this.data) {
        if (obj.hasOwnProperty(key)) {
          this.data[key] = obj[key]
        }
      }
      if (this.data.status === 1) {
        this.data.status = 0
      } else {
        this.data.status = 1
      }
      this.onUpdate()
    },
    onResultObj (response) {
      if (response.data.code >= 0) {
        return response.data.data
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
        return null
      }
      // loading.pop()
    },
    onResultSimple (response) {
      this.onResult(response, true, true)
    },
    onResult (response, IsNotLoad, IsNotClear) {
      if (response.status >= 0) {
        if (!IsNotClear) {
          this.onClear()
        }
        toast.success(this.$lang.Common.Alerts.Success)
        // this.$refs.alert.ShowSuccess()
        if (!IsNotLoad) {
          this.onLoad()
        }
      } else {
        // this.$refs.alert.ShowError
        toast.error(this.$lang.Common.Alerts.Error)()
      }
      loading.pop()
    },
    onResultGrid (response, tableGridRef) {
      if (response.status === 200) {
        this.objList = response.data.content
        if (tableGridRef) {
          tableGridRef.LoadAllByData(response)
        } else {
          this.$refs.tableGrid.LoadAllByData(response)
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()
    },
    onStartTotalGrid (tableGridRef, total) {
      tableGridRef.LoadStartTotalGrid(total)
    },
    onException (err) {
      if (err.message === 'Unauthorized' || err.message === 'ExpiredToken' || err.message === 'Cannot read properties of undefined (reading \'status\')') {
        toast.error(this.$lang.Common.SessionEnded)
      } else {
        toast.error(this.$lang.Common.MicroserviceUnavailable)
      }
      loading.pop()
    },
    onExceptionWithErrorMessage (err) {
      loading.pop()

      const defaultMessage = this.$lang.Common.DefaultErrorMessage

      if (err && err.data) {
        const { data } = err.response

        if (Array.isArray(data.errors) && data.errors.length > 0 && data.errors[0].message) {
          toast.error(`${defaultMessage} ${data.errors[0].message}`)
        } else if (typeof data === 'string') {
          toast.error(`${defaultMessage} ${data}`)
        }
      } else {
        this.onException(err)
      }
    },
    onResultDropdown (response, hasOpt, serializer) {
      var result = []
      // if (response.data.code >= 0) {
      var data = response.data.content
      for (var i in data) {
        // if (data[i].status) {
        if (serializer) {
          result.push({ 'text': serializer(data[i]), 'value': data[i].id })
        } else if (hasOpt) {
          result.push({ 'text': ' ' + data[i].nome, 'value': data[i].id })
        } else {
          result.push({ 'text': data[i].nome, 'value': data[i].id })
        }
        /*
        } else {
          result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
        }
        */
      }
      /*
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      */
      loading.pop()

      return result
    },
    onSetDropdown (data, hasOpt) {
      var result = []

      if (data && data.length > 0) {
        for (var i in data) {
          if (data[i].status) {
            if (hasOpt) {
              result.push({ 'text': ' &nbsp;&nbsp; ' + data[i].nome, 'value': data[i].id })
            } else {
              result.push({ 'text': data[i].nome, 'value': data[i].id })
            }
          } else {
            result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
          }
        }
      }

      return result
    },
    onResultSelect2 (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    onResultAutoComplete (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].alias) {
            result.push({ 'text': data[i].alias, 'value': data[i] })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i] })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    getIp () {
      ipify.ipv4()
        .then((ipv4) => {
          this.ip = ipv4
        })
        .catch(err => console.log(err))
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.setPosition)
      }
    },
    setPosition (position) {
      if (position) {
        this.latitude = position.coords.latitude
        this.longitude = position.coords.longitude
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/actionsForm.js